import React, { useContext, useCallback, useEffect, useState } from 'react';

import { v4 as uuidv4 } from 'uuid';

import { NCRContext } from 'views';
import { UserContext } from 'components/routing'

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';

import { PalletItem } from 'components/form/prototypes';

const Pallets = () => {

  const { state, setState } = useContext(NCRContext);
  const { user } = useContext(UserContext);

  const isDisabled =
    ['QA', 'GM'].includes(user.role)
      ? state.ncr.status.id > 8
      : state.ncr.status.id > 1;

  const addOrderItem = () => {
    setState(prev => {
      prev.ncr.return.returnPallets = [
        ...prev.ncr.return.returnPallets,
        {}
      ]
      return { ...prev };
    });
  }

  const updateItem = useCallback((uuid, event) => {
    setState(prev => {
      let index = prev.ncr.return.returnPallets.findIndex(item => item.uuid === uuid);
      prev.ncr.return.returnPallets = [...prev.ncr.return.returnPallets];
      prev.ncr.return.returnPallets[index] = {
        ...prev.ncr.return.returnPallets[index],
        ...event
      };
      return { ...prev };
    });
  }, [setState]);

  const deleteItem = useCallback(uuid => {
    setState(prev => {
      let index = prev.ncr.return.returnPallets.findIndex(item => item.uuid === uuid);
      prev.ncr.return.returnPallets = [...prev.ncr.return.returnPallets];
      prev.ncr.return.returnPallets.splice(index, 1);
      return { ...prev };
    });
  }, [setState]);

  const [itemHtml, setItemHtml] = useState([]);

  useEffect(() => {
    if (itemHtml.length !== state.ncr.return.returnPallets.length) {
      setItemHtml(
        state.ncr.return.returnPallets.map(item => {
          let uuid = uuidv4();
          item.uuid = uuid;
          return (
            <PalletItem
              id={uuid}
              key={uuid}
              selectedPallet={item.pallet_no}
              selectedWeight={item.weight}
              selectedDimension={item.dimensions}
              selectedType={item.type}
              callBackFunction={(event, name) => updateItem(uuid, event, name)}
              callBackFunctionDelete={() => deleteItem(uuid)}
              disabled={isDisabled}
            />
          )
        })
      );
    }
  }, [
    updateItem,
    deleteItem,
    isDisabled,
    itemHtml.length,
    state.currencies,
    state.ncr.return.returnPallets,
    state.ncr.subsidiary?.currency,
    state.products,
  ]);

  return (
    <>
      <Row className={'mb-2'}>
        <Col><h6>Pallets/Boxes</h6>
          <hr />
        </Col>
      </Row>
      <Row className={'mb-2'}>
        <Col md>
          <Row className={'mb-2'}>
            <Col xs={1} className={'my-auto'}>Pallet/Box No.</Col>
            <Col xs={3} className={'my-auto'}>Weight (KG)</Col>
            <Col xs={2} className={'my-auto'}>Dimensions (MM)</Col>
            <Col xs={2} className={'my-auto'}>Type</Col>
            <Col xs={1} className={'my-auto'}><FormControl className='invisible' /></Col>
          </Row>
          <Row className={'mb-2'}>
            <Col>
              {itemHtml}
            </Col>
          </Row>
          <Row className={'my-4 text-center'}>
            <Col>
              <Button
                variant='warning'
                disabled={isDisabled}
                onClick={addOrderItem}
              >
                Add Pallet +
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export { Pallets };
